const offsetX = 5;
const offsetY = 5;

export const customPointCanvasLeft = function (context: any, options: any) {
  // console.log('customPointCanvasLeft', { context, options });

  const isOverlapping = Math.abs(context.raw.dataL - context.raw.dataR) < offsetY;

  const cvs = document.createElement('canvas');
  const ctx = cvs.getContext('2d')!;
  const radius = options.pointRadius || 5;

  cvs.height = 2 * radius + 1;
  cvs.width = 2 * radius + 1;

  const centerX = cvs.width / 2;
  const centerY = cvs.height / 2;

  if (isOverlapping) {
    ctx.beginPath();
    ctx.lineWidth = 0.5;

    ctx.arc(centerX, centerY, radius, Math.PI / 2, Math.PI + Math.PI / 2, false);
    ctx.fillStyle = 'rgba(200, 200, 255, 1)';
    ctx.fill();
    ctx.strokeStyle = 'rgba(0, 0, 255, 1)';
    ctx.stroke();

    // ctx.arc(centerX, centerY, radius, Math.PI + Math.PI / 2, Math.PI / 2, false);
    // ctx.fillStyle = 'rgba(200, 200, 255, 0.1)';
    // ctx.fill();
    // ctx.strokeStyle = 'rgba(0, 0, 255, 0.1)';
    // ctx.stroke();

    ctx.closePath();

    ctx.font = '9px sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('L', centerX - offsetX, centerY);
  } else {
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius - 1, 0, 2 * Math.PI, false);
    ctx.fillStyle = 'rgba(200, 200, 255, 1)';
    ctx.fill();

    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(0, 0, 255, 1)';
    ctx.stroke();

    ctx.closePath();

    ctx.font = '10px sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('L', centerX, centerY);
  }

  return cvs;
};
export const customPointCanvasRight = function (context: any, options: any) {
  const isOverlapping = Math.abs(context.raw.dataL - context.raw.dataR) < offsetY;

  const cvs = document.createElement('canvas');
  const ctx = cvs.getContext('2d')!;
  const radius = options.pointRadius || 5;

  cvs.height = 2 * radius + 1;
  cvs.width = 2 * radius + 1;

  const centerX = cvs.width / 2;
  const centerY = cvs.height / 2;

  if (isOverlapping) {
    ctx.beginPath();
    ctx.lineWidth = 0.5;

    ctx.arc(centerX, centerY, radius, Math.PI + Math.PI / 2, Math.PI / 2, false);
    ctx.fillStyle = 'rgba(255, 200, 200, 1)';
    ctx.fill();

    ctx.strokeStyle = 'rgba(255, 0, 0, 1)';
    ctx.stroke();

    ctx.closePath();

    ctx.font = '9px sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('R', centerX + offsetX, centerY);
  } else {
    ctx.beginPath();
    ctx.arc(centerX, centerY, radius - 1, 0, 2 * Math.PI, false);
    ctx.fillStyle = 'rgba(255, 200, 200, 1)';
    ctx.fill();

    ctx.lineWidth = 1;
    ctx.strokeStyle = 'rgba(255, 0, 0, 1)';
    ctx.stroke();

    ctx.closePath();

    ctx.font = '10px sans-serif';
    ctx.fillStyle = 'black';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('R', centerX, centerY);
  }

  return cvs;
};
